import { render } from "./MobileNavigation.vue?vue&type=template&id=4575b5a4"
import script from "./MobileNavigation.vue?vue&type=script&lang=js"
export * from "./MobileNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../bfms-portal-template-manager-20261102/stage/fms_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__